import React from "react";
import Img from "../assets/Structure.jpg";
import DC from "../assets/StructureDC.pdf";
import PageHeader from "./PageHeader";

const Organizationstructure = () => {
  return (
    <>
      <PageHeader title="Organization Structure" />

      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          
          {/* Top Action Bar */}
          <div style={styles.topBar}>
            <a href={DC} download style={styles.downloadBtn}>
              📄 Download Full PDF
            </a>
          </div>

          {/* Image Card */}
          <div style={styles.card}>
            <img
              src={Img}
              alt="Organization Structure"
              style={styles.image}
            />
          </div>

        </div>
      </div>
    </>
  );
};

const styles = {
  pageWrapper: {
    backgroundColor: "#f5f7fa",
    padding: "40px 20px",
    minHeight: "100vh",
  },

  container: {
    maxWidth: "1100px",
    margin: "auto",
  },

  topBar: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },

  card: {
    backgroundColor: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    transition: "0.3s",
  },

  image: {
    width: "100%",
    height: "auto",
    borderRadius: "8px",
    transition: "0.3s",
  },

  downloadBtn: {
    display: "inline-block",
    padding: "12px 25px",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "8px",
    fontWeight: "600",
    transition: "0.3s",
  },
};

export default Organizationstructure;